import React from 'react';

import { Widget, WidgetHeader, WidgetHeading, WidgetIcon, WidgetTitle } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { PersonalMessagesBlock } from '../../_blocks/PersonalMessages';
import { SVGIcon } from '../../components/atoms/SVG';

export type CustomPersonalMessagesWidget = WidgetShape<[PersonalMessagesBlock], WidgetType.custompersonalmessages> & {
  iconId: string;
  title: string;
};

export function CustomPersonalMessagesWidget({
  blocks,
  uuid,
  elementType,
  title,
  iconId,
  header,
}: CustomPersonalMessagesWidget) {
  return (
    <Widget uuid={uuid} widgetType={elementType} header={header}>
      <WidgetHeader>
        <WidgetHeading hierarchy={3}>
          <WidgetIcon icon={iconId as SVGIcon} />
          <WidgetTitle>{title}</WidgetTitle>
        </WidgetHeading>
      </WidgetHeader>
      <PersonalMessagesBlock {...blocks[0]} />
    </Widget>
  );
}
